import React from 'react';
import styled from "styled-components";
import Skeleton from "react-loading-skeleton";


function CardFullSkeleton() {

    return (
        <div>
            <ImageCard>
                <Skeleton width="100%" height="100%"/>
            </ImageCard>

            <div className="mt-16">
                <Skeleton width="80%"/>
                <Skeleton width="100%"/>

                <div className="text-right">
                    <Skeleton width={100}/>
                </div>
            </div>
        </div>
    )
}

export default React.memo(CardFullSkeleton);

// styles

export const ImageCard = styled.div`
    position: relative;
    width: 100%;
    height: 180px;
    border-radius: 4px;
    
    @media (min-width: ${props => props.theme.screenXsMax}) and (max-width: ${props => props.theme.screenSmMax}) {
        height: 24vw !important;
    }
    
    @media (max-width: ${props => props.theme.screenXsMax}) {
        height: 40vw !important;
    }
`;

